var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppDialog',{attrs:{"height":"655","dialogName":"Onboarding text","width":"620"}},[_c('OnboardingFeatureDescriptionDialogContent',{attrs:{"workflowId":_vm.editWorkflow.id},on:{"close":_vm.close}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }